import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="about"
      className="py-24 lg:py-32 border-t border-[#E5E5E0]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-3">
          <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
            (About)
          </span>
          <h2 className="mt-4 font-serif-display text-4xl lg:text-5xl tracking-tighter text-[#1C1C1A] leading-tight">
            A small shop with a long memory.
          </h2>
        </div>

        <div className="lg:col-span-6 lg:col-start-5 space-y-6">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-sans-body text-lg text-[#1C1C1A] leading-relaxed"
            data-testid="about-paragraph-1"
          >
            JSE Painting Services started in the Fort Worth area more than five
            years ago with a simple promise: <em className="font-serif-display text-xl">do the
            small things right</em>, and the big things take care of themselves.
            That means clean lines, dust-controlled prep, paint matched to the
            light in your space, and a crew that respects your home like it's theirs.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-sans-body text-base text-[#4A4A46] leading-relaxed"
            data-testid="about-paragraph-2"
          >
            We paint interiors and exteriors, residential and commercial. We do
            the cabinets you keep meaning to refinish, the trim that's been
            chipped since you moved in, and the storefronts that need a refresh
            without closing for a week. Free estimates, honest pricing, and 24-hour
            availability when something can't wait.
          </motion.p>

          <motion.figure
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-10 border-l-2 border-[#CC5500] pl-6"
            data-testid="about-pullquote"
          >
            <blockquote className="font-serif-display text-3xl lg:text-4xl italic font-light leading-snug text-[#1C1C1A] tracking-tight">
              "The paint isn't the project.
              <br />
              The prep is. We prep like we'll have to look at it every day."
            </blockquote>
          </motion.figure>
        </div>
      </div>
    </section>
  );
}
